// types
import { WithdrawalApplication } from '../../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// ui
import { Table, TableHeader, TableProps } from '../../../ui/Table/Table';
import { Time } from '../../../ui/Time/Time';

// links
import { LinkWa } from '../../../links/LinkWa/LinkWa';

// props
export interface TableBasicWithdrawalApplicationsProps extends Omit<TableProps, 'headers'> {
	data: WithdrawalApplication[];
}

export const TableBasicWithdrawalApplications = ({
	data = [],
	...props
}: TableBasicWithdrawalApplicationsProps) => {
	// hooks
	const { t } = useTranslation();

	// vars
	const headers: TableHeader[] = [
		{
			label: t('id'),
			render: (
				idWbg: string | null | undefined,
				header: TableHeader,
				withdrawalApplication: WithdrawalApplication
			) => <LinkWa withdrawalApplication={withdrawalApplication} />,
			value: 'idWbg',
		},
		{
			label: t('created'),
			render: (created: string) => <Time date={created} />,
			value: 'created',
		},
	];

	return <Table {...props} data={data} headers={headers} />;
};
